<script setup>
import {Swiper, SwiperSlide} from "swiper/vue";
import {Autoplay, Navigation} from 'swiper/modules';
import 'swiper/css';
import CLink from "@/Components/CLink.vue";
import {useDisplay} from "vuetify";
import {computed} from "vue";

const props = defineProps({
    campaigns: Object
})

const modules = [Autoplay, Navigation];

const display = useDisplay()

const sizes = computed(() => {
    if (display.width.value <= 640) return 'small'
    if (display.width.value <= 1023) return 'medium'
    if (display.width.value <= 1439) return 'large'
    return 'extra-large'
})

const displayPromoCard = computed(() => {
    switch (sizes.value) {
        case 'small' : return (display.width.value / 3)
        case 'medium' : return (display.width.value / 4)
        case 'large' : return (display.width.value / 5)
        default : return (display.width.value / 5)
    }
})

const redirectLink = function (item) {
    const url = defaultUrl(item)

    if (url === '') {
        return '_self'
    }

    const urlObj = new URL(url);
    if (urlObj.host !== 'creativedesign.com.br') {
        return '_blank';
    } else {
        return '_self'
    }
}

const hasUrl = function (item) {
    return item.url &&
        typeof item.url === 'string' &&
        item.url.trim() !== ''
}

const defaultUrl = function (item) {
    return hasUrl(item) ? item.url : ''
}

</script>


<template>
    <v-sheet class="d-flex justify-center align-center mb-10">
        <div :style="{ width: display.width.value + 'px' }">
        <swiper
                :modules="modules"
                :slides-per-view="5"
                :pagination="{
                            clickable: true,
                            dynamicBullets: false
                        }"
                :navigation="{
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev'
                        }"
                :loop="true"
                :breakpoints="{
                            320: {slidesPerView: 3},
                            640: {slidesPerView: 3},
                            768: {slidesPerView: 4},
                            1024: {slidesPerView: 5}
                        }"
            >
                <swiper-slide v-for="campaign in campaigns" :key="campaign">
                    <v-card elevation="0" class="promo-card">
                        <div class="d-flex align-center justify-center">
                            <a :href="defaultUrl(campaign)" :target="redirectLink(campaign)">
                                <v-img :src="campaign.campaign_url" :width="displayPromoCard">
                                </v-img>
                            </a>
                        </div>
                    </v-card>
                </swiper-slide>
            </swiper>
            <v-row style="min-height: 55px" class="ma-0 bg-institutionalGrey">
                <v-col class="d-flex justify-start ms-3 mt-1">
                    <div class="swiper-button-prev"></div>
                    <div class="swiper-button-next"></div>
                </v-col>
                <v-col class="d-flex justify-end me-4 mt-2">
                    <c-link :href="route('campaigns')" class="promotion-link">
                        Confira todas as <strong>Campanhas</strong>
                    </c-link>
                </v-col>
            </v-row>
        </div>
    </v-sheet>
</template>

<style scoped>
.promo-card {
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    border-radius: 0 !important;
}

.swiper-slide {
    width: initial !important;
    justify-content: center;
}

.swiper-button-next,
.swiper-button-prev {
    position: relative;
    top: auto;
    left: auto;
    right: auto;
    margin: 0;
    width: 30px;
    height: 30px;
    color: white;
}

.swiper-button-next:after,
.swiper-button-prev:after {
    font-size: 1rem;
    font-weight: bolder;
}

.promotion-link {
    color: white;
    font-weight: 500;
    text-decoration: none;
    transition: all 0.3s ease;
    position: absolute;
}

.promotion-link:hover {
    color: #e6e6e6;
}

.promotion-link::after {
    content: '';
    position: absolute;
    width: 0;
    height: 2px;
    bottom: 0;
    left: 0;
    background-color: white;
    transition: width 0.3s ease;
}

.promotion-link:hover::after {
    width: 100%;
}

.promo-title-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 0;
}

.promo-title {
    font-size: 1rem;
    font-weight: bold;
    color: white;
}

@media (max-width: 640px) {
    .swiper-button-next:after,
    .swiper-button-prev:after {
        font-size: 1rem;
    }

    .promotion-link {
        font-size: 0.7rem;
    }

    .promo-title {
        font-size: 0.5rem;
    }
}
</style>
